define('modules/emblue/router',['require','exports','module','jquery','backbone','modules/private/index','modules/accounts/groups/index','./view','./model','env'],function (require, exports, module) {
  "use strict";

  var $ = require("jquery"),
    Backbone = require("backbone"),
    Private = require("modules/private/index"),
    Groups = require("modules/accounts/groups/index"),
    MainView = require("./view"),
    Emblue = require("./model"),
    Config = require("env");

  var init = function (tab, callback) {
    Private.init(
      function (me) {
        var group = new Groups.Model();
        var mainViewData = {
          el: "#content",
          me: me,
          group: group,
          tab: tab,
          status: false,
        };
        var mainView = new MainView(mainViewData);

        var productsFetch = function () {
          mainView.render();
          callback(me, group, mainView);
        };

        group.fetch({ success: productsFetch });
      },
      null,
      false
    );
  };

  var getUrlRedirect = function (redirect, query) {
    var bytesDecodificados = Uint8Array.fromBase64(redirect);
    var textoOriginal = new TextDecoder().decode(bytesDecodificados);
    var queryOriginal = "";
    if (!query) {
      return textoOriginal;
    }

    bytesDecodificados = Uint8Array.fromBase64(query);
    var queryOriginal = new TextDecoder().decode(bytesDecodificados);
    return textoOriginal + "?" + queryOriginal;
  };

  module.exports = Backbone.Router.extend({
    initialize: function () {},
    saveCps: false,
    hasBeenCreatedEmblueAccount: false,
    hasBeenCreatedEmblueAccountRetry: false,
    routes: {
      "savenewcps/(:redirect)(/:query)": "saveNewCps",
      "createemblueaccount/(:redirect)(/:query)": "createEmblueAccount",
    },

    saveNewCps: function (redirect, query) {
      var self = this;
      //https://signup.dev.mdirector.com/savenewcps/aHR0cHM6Ly9zaWdudXAuZGV2Lm1kaXJlY3Rvci5jb20vYWNjb3VudHM/Y29tcGFueV9pZD00MzM0OQ==
      var callback = function (me, group) {
        console.log("init saveNewCps function, ", self.saveCps);
        !self.saveCps &&
          group.save(
            {
              agreementsName: "EmBlueCPS",
            },
            {
              success: function (model) {
                var url = getUrlRedirect(redirect, query);
                window.location = url;
              },
              error: function (model, response) {
                console.log("error", response);
              },
            }
          );
        self.saveCps = true;
      };
      init("savenewcps", callback);
    },

    createEmblueAccount: function (redirect, query) {
      var self = this;
      //https://signup.dev.mdirector.com/createemblueaccount/aHR0cHM6Ly9zaWdudXAuZGV2Lm1kaXJlY3Rvci5jb20vYWNjb3VudHM/Y29tcGFueV9pZD00MzM0OQ==

      var callback = function (me, group, mainView) {
        console.log(
          "init createEmblueAccount function, ",
          self.hasBeenCreatedEmblueAccount,
          self.hasBeenCreatedEmblueAccountRetry
        );
        var emblue = new Emblue();
        !self.hasBeenCreatedEmblueAccount &&
          emblue.save(
            { isRetry: self.hasBeenCreatedEmblueAccountRetry },
            {
              success: function (model) {
                mainView.status = model.get("status");
                mainView.returnUrl = getUrlRedirect(redirect, query);

                mainView.render();

                if (model.get("status") == false) {
                  self.hasBeenCreatedEmblueAccount = false;
                  self.hasBeenCreatedEmblueAccountRetry = true;
                  self.createEmblueAccount(redirect, query);
                  //volver a hacer la llamada
                }
              },
              error: function (model, response) {
                console.log("error", response);
              },
            }
          );
        self.hasBeenCreatedEmblueAccount = true;
      };
      init("createemblueaccount", callback);
    },

    afterRender: function () {
      $(".i18n").i18n();
    },
  });
});

